import { useQueryClient } from '@tanstack/react-query';

import { useSecretMutation } from '@/hooks/use-secret-mutation';
import { sensitiveContentService } from '@/services/sensitive-content-service';
import type { SensitiveContentValue } from '@/types/core/sensitive-content';
import type { UUID } from '@/utils/uuid';

import {
  sensitiveContentMutationKeys,
  sensitiveContentQueryKeys,
} from './query-keys';

type RevealVariables = { connectorId: UUID; id: string };

/**
 * Reveal one row's value (audited). Resolves null when the row is gone and
 * refreshes the list so it drops out.
 */
export function useRevealSensitiveContent(tenantId: UUID) {
  const qc = useQueryClient();

  return useSecretMutation<SensitiveContentValue | null, RevealVariables>({
    mutationKey: sensitiveContentMutationKeys.reveal(tenantId),
    mutationFn: ({ connectorId, id }) =>
      sensitiveContentService.getValue(tenantId, connectorId, id),
    onSuccess: (result) => {
      if (result === null) {
        qc.invalidateQueries({
          queryKey: sensitiveContentQueryKeys.list(tenantId),
        });
      }
    },
  });
}
